import { GridItem, VStack, Text, ButtonGroup } from "@chakra-ui/react";
import { getCurrentSubscription } from "@syla/shared/types/helpers/subscriptions";
import { AccountPermission } from "@syla/shared/types/models/AccountAccessBase";
import React, { Fragment } from "react";
import { getUserDetails } from "../../../helper/getUserDetails";
import { hasAccountPermission } from "../../../helper/permissions";
import { useCurrentAccountStore } from "../../../store/currentAccountStore";
import { useQueryGetAccount } from "../../../store/useQueryGetAccount";
import { useQuerySubscriptions } from "../../../store/useQuerySubscriptions";
import { Subscription } from "../../../types/plans/subscription";
import { ManageBillingButton } from "./ManageBillingButton";
import { RemoveBillingOwnerButton } from "./RemoveBillingOwnerButton";

import { ValueAndButtons } from "./ValueAndButtons";

export function BillingOwnerDetails() {
  const accountId = useCurrentAccountStore(({ accountId }) => accountId);

  const { data: account } = useQueryGetAccount(accountId);

  const { data: subscriptions } = useQuerySubscriptions();

  if (!subscriptions || !account) {
    return null;
  }

  const currentSub = getCurrentSubscription(subscriptions.subscriptions);

  const showManageBillingButton =
    currentSub?.stripeSubscriptionId && currentSub.billingAccountAccess;

  const showRemoveBillingOwnerButton =
    currentSub &&
    !currentSub.billingAccountAccess &&
    currentSub.billingOwner &&
    hasAccountPermission(account, AccountPermission.ChangeAccess);

  return (
    <>
      <GridItem>
        <VStack alignItems="flex-start">
          <Text fontWeight="bold">Billing account owner</Text>
          <Text>
            The person responsible for paying the subscription on this account
          </Text>
        </VStack>
      </GridItem>
      <GridItem>
        <ValueAndButtons>
          <Text>{getBillingOwnerLabel(currentSub)}</Text>
          <ButtonGroup>
            {showManageBillingButton && (
              <ManageBillingButton accountId={accountId} />
            )}

            {showRemoveBillingOwnerButton && currentSub?.billingOwner && (
              <RemoveBillingOwnerButton
                accountId={accountId}
                billingOwnerId={currentSub.billingOwner._id}
              />
            )}
          </ButtonGroup>
        </ValueAndButtons>
      </GridItem>
    </>
  );
}

function getBillingOwnerLabel(subscription?: Subscription) {
  if (!subscription?.billingOwner) {
    return "None";
  }
  if (subscription.billingAccountAccess) {
    return "You";
  }
  return getUserDetails(subscription.billingOwner);
}
